import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/Watchlist.css';

const Watchlist = () => {
  return (
    <>
      <Helmet>
        <title>Watchlist - Track Stocks & Market Movers | Redbox Global</title>
        <meta name="description" content="Create and manage your personal stock watchlist with Redbox Global. Track real-time prices, get alerts, and stay informed on your portfolio and market opportunities." />
        <meta name="keywords" content="stock watchlist, portfolio tracker, stock alerts, market tracking, investment watchlist, stock monitoring, real-time quotes, portfolio management" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/watchlist" />
        <meta property="og:title" content="Watchlist - Track Stocks & Market Movers | Redbox Global" />
        <meta property="og:description" content="Create and manage your personal stock watchlist. Track real-time prices and get alerts on market opportunities." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/watchlist" />
        <meta name="twitter:title" content="Watchlist - Track Stocks & Market Movers | Redbox Global" />
        <meta name="twitter:description" content="Create and manage your personal stock watchlist. Track real-time prices and get alerts on market opportunities." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/watchlist" />
      </Helmet>
      
      <div className="page-container">
        <div className="page-header">
          <h1>Watchlist</h1>
          <p className="page-subtitle">Track your stocks and stay ahead of market opportunities</p>
        </div>
        
        <div className="page-content">
          <a href="/article/watchlist-top-movers-today" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="featured-article">
              <div className="featured-image">
                <img src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&h=600&fit=crop" alt="Stock watchlist" />
              </div>
              <div className="featured-content">
                
                <h2>Today's Top Movers: What's Driving Market Action</h2>
                <p>Track the stocks making the biggest moves today and understand the catalysts behind them. Our real-time watchlist highlights gainers, losers, and breakout candidates across all major indices. Get instant alerts on price movements, volume spikes, and analyst upgrades affecting your portfolio. Stay informed with personalized tracking tools and smart notifications.</p>
                <span className="article-meta">Updated Real-Time • Personalized Alerts Available</span>
              </div>
            </div>
          </a>

          <div className="content-grid">
            <a href="/article/watchlist-builder-guide" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop" alt="Building watchlist" />
                </div>
                <div className="article-content">
                  
                  <h2>How to Build an Effective Stock Watchlist</h2>
                  <p>Expert tips on creating a watchlist that helps you identify opportunities and manage risk.</p>
                  <span className="article-meta">10 min read</span>
                </div>
              </article>
            </a>

            <a href="/article/institutional-watchlist-insights" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop" alt="Institutional tracking" />
                </div>
                <div className="article-content">
                  
                  <h2>What Wall Street Is Watching This Week</h2>
                  <p>See the stocks institutional investors are adding to their watchlists and portfolios.</p>
                  <span className="article-meta">Weekly Update</span>
                </div>
              </article>
            </a>

            <a href="/article/watchlist-alerts-tutorial" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1563986768609-322da13575f3?w=600&h=400&fit=crop" alt="Alert settings" />
                </div>
                <div className="article-content">
                 
                  <h2>Smart Alerts: Never Miss a Market Move</h2>
                  <p>Configure custom alerts for price targets, earnings dates, analyst ratings, and news.</p>
                  <span className="article-meta">7 min read</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Watchlist;
